import React from "react";
import PageLayout from "../components/Layout/PageLayout";
import Products from "../components/Sections/Products";

export default function ProductsPage() {
  return (
    <PageLayout
      path="/products"
      title="Diagnostic Analyzers & Testing Systems | Finechek"
      description="Browse Finechek blood gas, biochemistry and hematology analyzers plus hemoglobin and glucose testing systems for laboratories and point-of-care testing."
    >
      <Products />
    </PageLayout>
  );
}
